<div class="input-area-wrapper input-area-wrapper-close" (click)="refocus()">
  @if (showLabel()) {
    <label
      for="sensorNameInput"
      class="select-label regular"
      style="align-self: flex-start"
    >
      {{ i18n.langString("sensor_name") }}
    </label>
  }

  <div
    class="input-area input-close input-drag drag-drop-space-reserve"
    [class.error-input]="showError() || showBorder()"
  >
    <div class="input-double-area">
      @if (prefix()) {
        <label
          class="select-label regular silver-chalice-text"
          style="align-self: flex-start"
        >
          {{ prefix() }}
        </label>
      }

      <input
        #sensorNameInput
        [ngModel]="name()"
        (ngModelChange)="onInputChange($event)"
        [maxlength]="35"
        [size]="calculateSize(name())"
        name="sensorNameInput"
        (focus)="keyPressAlphaNumeric($event)"
        (input)="keyPressAlphaNumeric($event)"
        (blur)="onInputFocusOut()"
        [ngClass]="showBorder() ? 'inputBorderAlert icons:info' : ''"
        [placeholder]="i18n.langString('sensor_name')"
        (input)="onTextInput($event)"
      />
    </div>
  </div>

  <div class="input-icon input-inline">
    @if (showError() || showAlert()) {
      <i
        nz-icon
        [nzType]="'icons:exclamation-mark-filled'"
        class="fillred error-icon"
      ></i>
    }
  </div>

  @if (displayValidation()) {
    <div class="display-alert-msg" [ngClass]="greyFlag() ? '' : 'redAlert'">
      <i
        nz-icon
        [nzType]="showAlert() ? 'icons:cross-circle' : 'icons:done-full-circle'"
        class="svg-icon alert-error-icon"
      ></i>
      {{ i18n.langString("special_Characters_Not_Allowed") }}
    </div>

    <div class="display-alert-msg">
      <i
        nz-icon
        [nzType]="'icons:done-full-circle'"
        class="svg-icon alert-error-icon"
      ></i>
      {{ i18n.langString("not_more_than_35_chars") }}
    </div>
  }
</div>
